import { Component, ViewChild } from '@angular/core';
import { Nav, Platform } from 'ionic-angular';

import { Mapa } from '../pages/mapa/mapa';
import { Llista } from '../pages/llista/llista';
import { Favorits } from './../pages/favorits/favorits';
import { Credits } from './../pages/credits/credits';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any = Mapa;

  pages: Array<{
    title: string,
    component: any,
    icon:string,
    link: boolean
  }>;

  constructor(public platform: Platform) {
    this.initializeApp();

    // used for an example of ngFor and navigation
    this.pages = [
      { title: 'Mapa', component: Mapa, icon:'map', link:false },
      { title: 'Llista', component: Llista, icon:'list', link:false },
      { title: 'Favorits', component: Favorits,  icon:'star', link:false },
      { title: 'Manlleu Empreses', component: 'http://www.manlleuempreses.com',  icon:'pin', link:true },
      { title: 'Crèdits', component: Credits,  icon:'information-circle', link:false },
      //,{ title: 'Accés Directe', component: '',  icon:'link', link:false }
    ];

  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      /*StatusBar.styleDefault();
      Splashscreen.hide();*/
    });
  }

  openPage(page) {
    if(page.link){
      window.location.href = page.component;
    }else{
      this.nav.setRoot(page.component);
      if(page.component !== '') {
        this.nav.setRoot(page.component)
    }
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts